import React from 'react';
import TextareaAutosize from 'react-textarea-autosize';
import jss from 'jss';

import theme from 'utils/theme';

const styles = ({ margin, width, focused, type, height }) => ({
    inputWrapper: {
        fontSize: '14px',
        lineHeight: '18px',
        margin: margin || 'initial',
        paddingTop: type === 'textarea' ? '20px' : '13px',
        position: 'relative',
        width: width || 'initial',

        '& label': {
            color: theme.colors.grey300,
            fontSize: '10px',
            left: '0',
            position: 'absolute',
            top: '0',
            '&.error-field': {
                color: theme.colors.error500,
            },
        },

        '& input': {
            color: `${theme.colors.black}`,
            fontFamily: 'CircularStd',
            padding: '3px 0 6px 0',
            borderBottom: `1px solid ${theme.colors.grey300}`,
            fontSize: '14px',

            '&.error-field': {
                borderBottom: `1px solid ${theme.colors.error500}`,
                color: `${theme.colors.black}`,
            },
        },
        '& input::placeholder': {
            color: `${theme.colors.grey300}`,
            fontFamily: 'CircularStd',
        },

        '& .textarea-area': {
            border: `1px solid ${focused ? theme.colors.caramel400 : theme.colors.blue200}`,
            padding: '0 8px 0 21px',
        },

        '& .textarea-area p': {
            textAlign: 'right',
            fontSize: '10px',
            color: `${theme.colors.grey300}`,
            margin: '0',
            padding: '0',
        },

        '& textarea': {
            border: 0,
            color: `${theme.colors.black}`,
            fontFamily: 'CircularStd',
            fontSize: '12px',
            padding: '17px 0 0 0',
        },
        '& textarea::placeholder': {
            color: `${theme.colors.grey300}`,
            fontFamily: 'CircularStd',
        },
    },
});
export default class TextField extends React.Component {
    constructor(props, context) {
        super(props, context);

        this.state = {
            value: props.value || '',
            label: props.label || '',
            focused: false,
        };
        this.id = props.id || Math.random().toString(36).substr(2, 5);
    }

    componentWillReceiveProps(props) {
        const state = {
            value: props.value || '',
            label: props.label || '',
        };

        this.setState(state);
    }

    onChangeCallback = (e) => {
        const value = e.target.value;
        if (this.props.onChange) {
            this.props.onChange(value);
        } else {
            this.setState({ value });
        }
    };

    onFocus = () =>
        this.setState({ focused: true }, () => {
            if (this.props.onFocus) {
                this.props.onFocus(this.state.focused);
            }
        });

    onBlur = () =>
        this.setState({ focused: false }, () => {
            if (this.props.onBlur) {
                this.props.onBlur(this.state.focused);
            }
        });

    focus = () => {
        const input = document.getElementById(this.id);
        input.focus();
    };

    _renderInput() {
        const { placeholder, max, min, maxLength, step, disabled, autoComplete } = this.props;
        const { value } = this.state;
        const type = this.props.type || 'text';

        if (type === 'textarea') {
            return (
                <div className="textarea-area">
                    <TextareaAutosize
                        id={this.id}
                        value={value}
                        placeholder={placeholder}
                        maxLength={maxLength || 150}
                        disabled={disabled}
                        onChange={this.onChangeCallback}
                        onFocus={this.onFocus}
                        onBlur={this.onBlur}
                    />
                    <p>
                        {value.length} / {maxLength}
                    </p>
                </div>
            );
        }

        return (
            <input
                id={this.id}
                type={type}
                value={value}
                placeholder={placeholder}
                maxLength={maxLength}
                max={max}
                min={min}
                step={step}
                disabled={disabled}
                autoComplete={autoComplete}
                onChange={this.onChangeCallback}
                onFocus={this.onFocus}
                onBlur={this.onBlur}
                className={this.props.error || ''}
            />
        );
    }

    render() {
        const { label, value, focused } = this.state;
        const { customStyles, placeholder, type } = this.props;
        const { classes } = jss
            .createStyleSheet(styles({ ...customStyles, focused, type }))
            .attach();

        return (
            <div className={classes.inputWrapper}>
                {this._renderInput()}
                {label && (
                    <label htmlFor={this.id} className={this.props.error || ''}>
                        {label}
                    </label>
                )}
                {value && (
                    <label htmlFor={this.id} className={this.props.error || ''}>
                        {label || placeholder}
                    </label>
                )}
            </div>
        );
    }
}
